import { SpaceLayout } from "@/data";
import { useMediaQuery } from "@/hooks";
import classNames from "classnames";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { colors } from "../colors";

interface SpaceLayoutDetailsProps {
  layouts: SpaceLayout[];
}

export function SpaceLayoutDetails({ layouts }: SpaceLayoutDetailsProps) {
  const { device } = useMediaQuery();
  const isDesktop = device === "desktop";

  const [openAllLayoutsModal, setOpenAllLayoutsModal] = useState(false);

  if (layouts.length === 0) {
    return null;
  }

  const renderLayout = (details: SpaceLayout) => {
    return (
      <div
        key={details.id}
        className={classNames(
          "d-flex gap-3",
          !isDesktop ? "flex-column" : "align-items-center"
        )}
      >
        <div>
          <div
            style={{ width: 152, height: 152 }}
            className="border rounded d-flex align-items-center justify-content-center"
          >
            <img src={details.imageURL} alt={details.name} width="100%" />
          </div>
        </div>
        <div>
          <div className="fw-bold">{details.name}</div>
          <div className="mt-1" style={{ color: colors.blackMinus40 }}>
            Up to {details.capacity} guests
          </div>
          <div className="mt-1">{details.description}</div>
        </div>
      </div>
    );
  };

  const seeAllLayoutsComponent = (
    <div className="mt-4">
      <Button
        variant="outline-primary"
        onClick={() => setOpenAllLayoutsModal(true)}
      >
        See all space layouts
      </Button>
      <Modal
        show={openAllLayoutsModal}
        onHide={() => setOpenAllLayoutsModal(false)}
        size="lg"
        centered
        className="header-center"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title as="b">All space layouts</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 600 }}>
          <div className="d-flex flex-column gap-4">
            {layouts.map(renderLayout)}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );

  if (!isDesktop) {
    return (
      <div>
        <h3>Space layouts</h3>
        <div className="mt-3 d-flex flex-column gap-4">
          {renderLayout(layouts[0])}
        </div>
        {layouts.length > 1 && seeAllLayoutsComponent}
      </div>
    );
  }

  const firstTwoLayouts = layouts.slice(0, 2);

  return (
    <div>
      <h3>Space layouts</h3>
      <div className="mt-3 d-flex flex-column gap-4">
        {firstTwoLayouts.map(renderLayout)}
      </div>
      {layouts.length > 2 && seeAllLayoutsComponent}
    </div>
  );
}
